
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqGuiLzHkQxPEV2gqFeRiNJLy0cs5LmhLorutdkXaNUEUMeta } from "/codebuild/output/src1917730176/src/src/pages/faq.vue?macro=true";
import { default as menu_XGk4kLDNRmHMsj_YsuSLmGqKjsXkfz0bBn5U82W7coMeta } from "/codebuild/output/src1917730176/src/src/pages/menu.vue?macro=true";
import { default as index3XbV2y50w59ABICyIiMP7OVubUgDOCCy_OqCfKpaaroMeta } from "/codebuild/output/src1917730176/src/src/pages/index.vue?macro=true";
import { default as contactjOV_45y5b5etiT8YJLNg2_S2YBTjDozrH_RKlIQtibpc0Meta } from "/codebuild/output/src1917730176/src/src/pages/contact.vue?macro=true";
import { default as tutorialTC3hMAqpT_45YYzME31tYd2NDQVtgXh8iz1ij6nrN6JVwMeta } from "/codebuild/output/src1917730176/src/src/pages/tutorial.vue?macro=true";
import { default as agreementWemppe_vtj0DR3O3RQLfTE_ECcLlUH_45JyCf8u0xEdh0Meta } from "/codebuild/output/src1917730176/src/src/pages/agreement.vue?macro=true";
import { default as about_45passCLvvoqSYsmQWpS2OO6Jzx28Cy9ziSSZgwYOHN_45wizK8Meta } from "/codebuild/output/src1917730176/src/src/pages/about-pass.vue?macro=true";
import { default as index202Pghr4_c3APkV4K4Ty_45F3xqPEfGjNNDKYPtdh2Bm0Meta } from "/codebuild/output/src1917730176/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93j_45esTbxJlHUpDdDf6OCmC1xQ_EHJk7UGLLsuQNXUapMMeta } from "/codebuild/output/src1917730176/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance2Wwc7UFezmDLAq4nvphjbpxHn2ADiJFRAFHIFpgXsTUMeta } from "/codebuild/output/src1917730176/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93E4eEUaxc0L3c6UeDQRfFEMZYQs0XPrhxR1kNPOZyZ84Meta } from "/codebuild/output/src1917730176/src/src/pages/notice/[id].vue?macro=true";
import { default as indexorpfW1HV_45D16HrZ5lam74zBZ5HUDjnAPmC1hn2sGBi8Meta } from "/codebuild/output/src1917730176/src/src/pages/coupon/index.vue?macro=true";
import { default as index9yf2DOPSbZEaDBNN5IAElcYsJibFErP35eV9phezdmwMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/index.vue?macro=true";
import { default as indexsK3z5RfufNGWRttTX6Kmu3eY52SeImqophP5QRdeRFMMeta } from "/codebuild/output/src1917730176/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93ua6NXM8G6wfE09qv8dgDOxWQTjdLwyZvPRcKJmrXyuYMeta } from "/codebuild/output/src1917730176/src/src/pages/parking/[id].vue?macro=true";
import { default as indexLQMELXdXTlFTinEWLPSlR2kgSpzm6Z_siZ1yBuDhdxgMeta } from "/codebuild/output/src1917730176/src/src/pages/history/index.vue?macro=true";
import { default as indexRBjKHcKLpvJ1cRXQsrh47jmkp6bLoHFfwnZF9GPJM_8Meta } from "/codebuild/output/src1917730176/src/src/pages/monthly/index.vue?macro=true";
import { default as indexxF9HmAyJaDXhQU0DICSv5rziJYnPqbcdI4pLGKoolQcMeta } from "/codebuild/output/src1917730176/src/src/pages/sign-in/index.vue?macro=true";
import { default as indextAQQHpmhRI_452uamVD64KlrrF_45bcYwIwcGZPQF8KRHFsMeta } from "/codebuild/output/src1917730176/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviwDMvgaBfjCzWpbfCA5woJfDxKFM8nlQPxzZ7Gwo_1d4Meta } from "/codebuild/output/src1917730176/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editNN334oJR9eNwRWXpuxo1YSZFvM5DyWX3J4KGwPvtTIYMeta } from "/codebuild/output/src1917730176/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementxZErXmXOBKyLh2KvnQSvqZHOtbBQzSCXnUdh14ce5ocMeta } from "/codebuild/output/src1917730176/src/src/pages/pass-agreement.vue?macro=true";
import { default as index4F0hCgGfh44Sc6Vquy0kTRfqGb_6e938eu3PumrJZVkMeta } from "/codebuild/output/src1917730176/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dUVPPBZ5YAievgTZSQ7G0g_mRpk2NjZlukrZn82l9ELYMeta } from "/codebuild/output/src1917730176/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmh2C1syV3ISR3TR1z7nKQ5QSDKkBiQ_45J5AAJBlucjGsUMeta } from "/codebuild/output/src1917730176/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexfdmUxHdNS99heK9JIcHvMEOpA_Yolyo17MSjM4XZ96YMeta } from "/codebuild/output/src1917730176/src/src/pages/card/create/index.vue?macro=true";
import { default as indexI5PpBuqCpcEa1o7Wkh_a29xgbpCsf9_45bjcFydBiYjwsMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmjh0_YVTuJ0YVYV8oqjgliCpr2P8wC1oZgPphj4l3wzwMeta } from "/codebuild/output/src1917730176/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmrwkKcExeyape8xUfiQ1qOu0OGebGf_45KWYcUiv1fh57cMeta } from "/codebuild/output/src1917730176/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete9NTCloSKeWEtCYIuvfnJJnBZKjjzrm7p9GZWwKEQVaYMeta } from "/codebuild/output/src1917730176/src/src/pages/membership/complete.vue?macro=true";
import { default as registerh0KNKKoejQcEiIb6mSKphqSL3VSYtBjFixRTfyKj494Meta } from "/codebuild/output/src1917730176/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93blpBQbaNXraB_4alScsu7QY5OkgfUVnFTZtOsxaABOUMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmOojJR6pa7s1ewLi7fCMELqvyUh1Vl_XnBG3xNL69uk4Meta } from "/codebuild/output/src1917730176/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_937jT25qh91FV7rlIAZLBZK1RzgjBjFYR_45u6lv8GUhq6UMeta } from "/codebuild/output/src1917730176/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexmYgtfJeTU1peAmEV12_awjAB3ug6CsnWNn79UQmRHSEMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code4clCVdiPSrDinD1F2J5MrSjvO4KUIqGkTTTt1Lmo6jMMeta } from "/codebuild/output/src1917730176/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codelmJKweU_w2ChjIybPBjT2kOKmzw565jwzih8742l4SoMeta } from "/codebuild/output/src1917730176/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completek7jkr9JPDfiEAgyKM3N91M6YRWDrpRc0ftX_45w_45t80BcMeta } from "/codebuild/output/src1917730176/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerndouz96HSQ97zSgG8REBL7l6zHB7beOROa_45A_45sBqDjoMeta } from "/codebuild/output/src1917730176/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete8lflKkitrr2DRLboXJ9yLOQO5Egf8xbSSJVsq_L4_icMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index0DMM9Gbq4cP0befbDpu1dbhhgTAeoCEFB9bHRg71D9oMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm5BxhEbfDgsN0Lmc63snmI2CeW4Kxm_45LyUs76iU8wOVkMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeDOjXW_45H9DOzxn51RaJ8HkPTCxQ6xdim4VUOXPNdcVU0Meta } from "/codebuild/output/src1917730176/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexRiv3JY300g8jYrbStNae8Jkikq_AtWq6OCLTPV3rtFIMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93sLz7tMtwAcoMl_45bir2O0Yz7E9BUYcLdEVfNo5mMGUXwMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeikTZdE_1ywfrQaqBUwc1_45bE1uZ9CitMI74MiWasffYcMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasNc592VogM_457CIWGDwfVZNgbIDXGAET4PCh9LC9Wjd9IMeta } from "/codebuild/output/src1917730176/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample9wTX45fkwUgV_45wqoPQIsUjelfQtaLR1JV4sB7g8UbtkMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email1YAdr9yQojuulPWQQWUqC7Vlko91_455165Icc_45U3Yto0Meta } from "/codebuild/output/src1917730176/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmycoLlMCqKlgbQOzcwIhx9eEHh_45dYbrwawKFLH4MC2WcMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentEu7YlcBV5I2vDQ5t4FqS0_45tYWhOY4qC1Uc9g3JN2_uQMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmMYwQLIIZLIPZebd7sQgWkVZSuhanIi1rmKaJwxvdchsMeta } from "/codebuild/output/src1917730176/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate_ssvvljJEauIuXCbBMNZIcbJYCKj4BQ1XP4OqrI433YMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeu1DH6hWMs2nwDE7ta1dUQBG2l_xid2W2qKJU1yKFQlMMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code_45al4drGUo2otLLdHdzvbr0dmW8pme2O4qpNK9f1mvlMMeta } from "/codebuild/output/src1917730176/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordO0E0SLy0qJvAUXO04ZrGS_6mqfgGAOEHPz9_k5B_45OHQMeta } from "/codebuild/output/src1917730176/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasJzWY0TdhLtf5hqhAsrr_45Di996J1RA2V__45_nXrGbrA_45oMeta } from "/codebuild/output/src1917730176/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register1gpbjkaJN_45SEUlnoZdVXTUeH78rLiIN6Ujxf9l2T3igMeta } from "/codebuild/output/src1917730176/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeiQXNEc36hmQwrKzr6_zWG60yetUDhzd7UJmqqMF6kT0Meta } from "/codebuild/output/src1917730176/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexoCR0zeFztY334RBSCrlEQskrmG62Kq2RDtQuWGNU9O8Meta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index4lQmy_45RMbZSOVGQUOCHYSZbBJXv3DbcUynuN0vUyn18Meta } from "/codebuild/output/src1917730176/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexlx1F4HMh3W_45yJcfXAM6FY9U0Q9bD1qAfOzkvycAjBu8Meta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexhCwzQ7GWWSs3VLlXMBobKMqTmG7Ok8cshbtemf3zB2oMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateKLucdJ1qumkF0kKqulokh9zl_fYfv3mfNx00BHLNQEQMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completemi3JeQcO18cUzZomgWlSK1KttmcadxvlDzDVIQfa1R4Meta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmOnYMXL9nVeSK4NFK3xJyg64pSS8OPtskajQ5C16ZyqEMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexN6ypcmlGwkWxqQr7OkBP9fUu3hBEog_45pssPkXPiEKy0Meta } from "/codebuild/output/src1917730176/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completebj7U4p89tGuKfThlaMx73EbVtj9Tg0HVIW0Ai_45_45L8wMMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatejGu_pfbhdtkFA3eDalReB7GVZ1XJbY3xrJzYVTs6YVQMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index65PBtqEIVImX8J71mZbCL2BvX91ILaWoBs4HTqGzGREMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexvCRukJHko7PP5WYmnZ47nQdy_VBujaRpSI6vbvBqT4cMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completehEEe0iNf7mYgpCIz4RBLJpy3R19CVW9JcTe5M5SCY6AMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexONZgT5FUZPPRnew3l6ZsTbY8bYM9bGSet7qpjqV_KjgMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code8KIMye5dMpl530yhNwTMMgY_Hcw38S7I9GXmmU9dFUwMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexbdOWTeLBnMBdLmOVwKUaNrv4FgdRrqY8FdHVPXFqgboMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexvOGcMgsZD1uPCYgR6uODj1O6Q1EQm4GJI3JmtAu_pu4Meta } from "/codebuild/output/src1917730176/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index3jX1mkVlfajDh6mkdmU_45VW5cJgO5lcP0As3ApAJjbGwMeta } from "/codebuild/output/src1917730176/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatemNTpw5pmzmiJLEvfLqSQhXMahqTB9TY_45sf2sRm7CnPgMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmI8A8h_45aFbLVLApUH8MhSQAhnMLjwIfWTOwSGv8EnUbEMeta } from "/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu_XGk4kLDNRmHMsj_YsuSLmGqKjsXkfz0bBn5U82W7coMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index3XbV2y50w59ABICyIiMP7OVubUgDOCCy_OqCfKpaaroMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexorpfW1HV_45D16HrZ5lam74zBZ5HUDjnAPmC1hn2sGBi8Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexLQMELXdXTlFTinEWLPSlR2kgSpzm6Z_siZ1yBuDhdxgMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexxF9HmAyJaDXhQU0DICSv5rziJYnPqbcdI4pLGKoolQcMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indextAQQHpmhRI_452uamVD64KlrrF_45bcYwIwcGZPQF8KRHFsMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexfdmUxHdNS99heK9JIcHvMEOpA_Yolyo17MSjM4XZ96YMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmjh0_YVTuJ0YVYV8oqjgliCpr2P8wC1oZgPphj4l3wzwMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmrwkKcExeyape8xUfiQ1qOu0OGebGf_45KWYcUiv1fh57cMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete9NTCloSKeWEtCYIuvfnJJnBZKjjzrm7p9GZWwKEQVaYMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerh0KNKKoejQcEiIb6mSKphqSL3VSYtBjFixRTfyKj494Meta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmOojJR6pa7s1ewLi7fCMELqvyUh1Vl_XnBG3xNL69uk4Meta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code4clCVdiPSrDinD1F2J5MrSjvO4KUIqGkTTTt1Lmo6jMMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codelmJKweU_w2ChjIybPBjT2kOKmzw565jwzih8742l4SoMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completek7jkr9JPDfiEAgyKM3N91M6YRWDrpRc0ftX_45w_45t80BcMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerndouz96HSQ97zSgG8REBL7l6zHB7beOROa_45A_45sBqDjoMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm5BxhEbfDgsN0Lmc63snmI2CeW4Kxm_45LyUs76iU8wOVkMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeDOjXW_45H9DOzxn51RaJ8HkPTCxQ6xdim4VUOXPNdcVU0Meta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexRiv3JY300g8jYrbStNae8Jkikq_AtWq6OCLTPV3rtFIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeikTZdE_1ywfrQaqBUwc1_45bE1uZ9CitMI74MiWasffYcMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample9wTX45fkwUgV_45wqoPQIsUjelfQtaLR1JV4sB7g8UbtkMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email1YAdr9yQojuulPWQQWUqC7Vlko91_455165Icc_45U3Yto0Meta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmycoLlMCqKlgbQOzcwIhx9eEHh_45dYbrwawKFLH4MC2WcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentEu7YlcBV5I2vDQ5t4FqS0_45tYWhOY4qC1Uc9g3JN2_uQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmMYwQLIIZLIPZebd7sQgWkVZSuhanIi1rmKaJwxvdchsMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeu1DH6hWMs2nwDE7ta1dUQBG2l_xid2W2qKJU1yKFQlMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code_45al4drGUo2otLLdHdzvbr0dmW8pme2O4qpNK9f1mvlMMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordO0E0SLy0qJvAUXO04ZrGS_6mqfgGAOEHPz9_k5B_45OHQMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register1gpbjkaJN_45SEUlnoZdVXTUeH78rLiIN6Ujxf9l2T3igMeta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeiQXNEc36hmQwrKzr6_zWG60yetUDhzd7UJmqqMF6kT0Meta || {},
    component: () => import("/codebuild/output/src1917730176/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1917730176/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]